import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';

export const makeServicesActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Get Keys',
				id: 'getKeys',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkPreProd,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.listKeys,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			},
			{
				name: 'Show Update Requests',
				id: 'getAllPendingZkUpdateReqs',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkPreProd,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.getAllPendingZkUpdateReqs,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		]
	};
};

export const makeUpdateReqsActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Approve',
				id: 'approveUpdateReq',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkPreProd,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.updateZKUpdateReq,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			},
			{
				name: 'Reject',
				id: 'rejectUpdateReq',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkPreProd,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.updateZKUpdateReq,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		]
	};
};

export const makeKeysActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'View Key',
				id: 'viewKey',
				isEnabled: () => {
					return hasPermission({
						entity: GAME_ADMIN_RESOURCES.zkPreProd,
						action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.getValueForKey,
						appName,
						configPageName: PAGE_NAMES.gameAdmin
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'addKey',
			isEnabled: () => {
				return hasPermission({
					entity: GAME_ADMIN_RESOURCES.zkPreProd,
					action: GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkPreProd]?.updateKey,
					appName,
					configPageName: PAGE_NAMES.gameAdmin
				});
			}
		}
	};
};
